import React, { useState } from "react";

const ROW_NUMBERS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
const ROW_1 = ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"];
const ROW_2 = ["a", "s", "d", "f", "g", "h", "j", "k", "l"];
const ROW_3 = ["z", "x", "c", "v", "b", "n", "m"];

const SYMBOLS_ROW_1 = ["@", "#", "$", "_", "&", "-", "+", "(", ")", "/"];
const SYMBOLS_ROW_2 = ["*", '"', "'", ":", ";", "!", "?", "."];
const SYMBOLS_ROW_3 = ["%", "~", "`", "|", "\\", "<", ">", "[", "]", "{", "}"];

const VirtualKeyboard = ({ onKeyPress, onBackspace, onSpace, onDone }) => {
  const [isShift, setIsShift] = useState(false);
  const [isSymbols, setIsSymbols] = useState(false);

  const handleKey = (key) => {
    onKeyPress(isShift && !isSymbols ? key.toUpperCase() : key);
    if (isShift) setIsShift(false);
  };

  return (
    <div className="virtual-keyboard">
      <div className="vk-row">
        {ROW_NUMBERS.map((key) => (
          <button
            type="button"
            key={key}
            className="vk-key"
            onClick={() => handleKey(key)}
          >
            {key}
          </button>
        ))}
      </div>

      {isSymbols ? (
        <>
          <div className="vk-row">
            {SYMBOLS_ROW_1.map((key) => (
              <button
                type="button"
                key={key}
                className="vk-key"
                onClick={() => handleKey(key)}
              >
                {key}
              </button>
            ))}
          </div>
          <div className="vk-row">
            {SYMBOLS_ROW_2.map((key) => (
              <button
                type="button"
                key={key}
                className="vk-key"
                onClick={() => handleKey(key)}
              >
                {key}
              </button>
            ))}
          </div>
          <div className="vk-row">
            {SYMBOLS_ROW_3.map((key) => (
              <button
                type="button"
                key={key}
                className="vk-key"
                onClick={() => handleKey(key)}
              >
                {key}
              </button>
            ))}
            <button
              type="button"
              className="vk-key vk-key-wide vk-backspace"
              onClick={onBackspace}
            >
              ⌫
            </button>
          </div>
        </>
      ) : (
        <>
          <div className="vk-row">
            {ROW_1.map((key) => (
              <button
                type="button"
                key={key}
                className="vk-key"
                onClick={() => handleKey(key)}
              >
                {isShift ? key.toUpperCase() : key}
              </button>
            ))}
          </div>
          <div className="vk-row">
            {ROW_2.map((key) => (
              <button
                type="button"
                key={key}
                className="vk-key"
                onClick={() => handleKey(key)}
              >
                {isShift ? key.toUpperCase() : key}
              </button>
            ))}
          </div>
          <div className="vk-row">
            <button
              type="button"
              className={`vk-key vk-key-wide vk-shift${isShift ? " vk-active" : ""}`}
              onClick={() => setIsShift((prev) => !prev)}
            >
              ⇧
            </button>
            {ROW_3.map((key) => (
              <button
                type="button"
                key={key}
                className="vk-key"
                onClick={() => handleKey(key)}
              >
                {isShift ? key.toUpperCase() : key}
              </button>
            ))}
            <button
              type="button"
              className="vk-key vk-key-wide vk-backspace"
              onClick={onBackspace}
            >
              ⌫
            </button>
          </div>
        </>
      )}

      <div className="vk-row">
        <button
          type="button"
          className="vk-key vk-key-123"
          onClick={() => setIsSymbols((prev) => !prev)}
        >
          {isSymbols ? "ABC" : "123"}
        </button>
        <button
          type="button"
          className="vk-key"
          onClick={() => handleKey("@")}
        >
          @
        </button>
        <button
          type="button"
          className="vk-key"
          onClick={() => handleKey(".")}
        >
          .
        </button>
        <button
          type="button"
          className="vk-key vk-space"
          onClick={onSpace}
        >
          Space
        </button>
        <button
          type="button"
          className="vk-key vk-key-wide vk-done"
          onClick={onDone}
        >
          Done
        </button>
      </div>
    </div>
  );
};

export default VirtualKeyboard;
